import { isUUID } from '__core/shared/util/validate';

/* eslint-disable no-param-reassign */
/* @ngInject */

export default (
  $anchorScroll,
  $q,
  $rootScope,
  $scope,
  $location,
  $timeout,
  $stateParams,
  $window,
  webpage,
  accountService,
  accountsService,
  organizationService,
  mailChimpService,
  campaignMonitorService,
  navigationService,
  authenticationService,
  uiService,
  INSTANCE
) => {
  $scope.Model = {
    canManageCampaignMonitor: INSTANCE.isCampaignMonitorEnabled
      ? ($rootScope.CurrentOrganization.isRoot() && authenticationService.isAdministrator()) ||
        (!$rootScope.CurrentOrganization.isRoot() && authenticationService.isManager()) ||
        (!$rootScope.CurrentOrganization.isRoot() &&
          authenticationService.isAdministrator() &&
          $rootScope.CurrentOrganization.enterprise.integrations.allowCampaignMonitor)
      : false,
    canManageMailChimp:
      ($rootScope.CurrentOrganization.isRoot() && authenticationService.isAdministrator()) ||
      (!$rootScope.CurrentOrganization.isRoot() && authenticationService.isManager()) ||
      (!$rootScope.CurrentOrganization.isRoot() &&
        authenticationService.isAdministrator() &&
        $rootScope.CurrentOrganization.enterprise.integrations.allowMailChimp),
    showBankStatements: false,
    showCampaignMonitor: false,
    showCampaignMonitorAutoSync: false,
    showMailChimpAutoSync: false,
    isLoanQEnabled: $rootScope.hasLoanQEnabled(),
    showLoanq: false,
    loanqUrl: 'https://www.loanq.com.au',
    isAdministrator: authenticationService.isAdministrator(),
    isReady: false
  };

  webpage.pageTitle('Loading, please wait');
  $q.when()
    .then(() => {
      if ($stateParams.code === 'mailchimp' && $rootScope.CurrentAccount.isAdministrator) {
        return mailChimpService.authenticated({ code: $stateParams.code });
      }
      return null;
    })
    .then((response) => {
      if (response?.status && response?.provider) {
        uiService.toast({
          text: {
            p1: 'Authentication with',
            p2: response.provider,
            p3: 'completed successfully'
          },
          success: true
        });
      }
      if (!response?.status && response?.provider) {
        uiService.toast({
          text: {
            p1: 'Authentication with',
            p2: response.provider,
            p3: 'has failed'
          },
          warn: true
        });
      }
      return $q.all([
        accountService.readAccount({ id: $rootScope.CurrentAccount.id }),
        $rootScope.CurrentAccount.isAdministrator
          ? organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id })
          : null
      ]);
    })
    .then((data) => {
      // Overwrite $rootScope values in case they've reverted to values within Token
      $rootScope.CurrentAccount.integrations = data[0]?.integrations;
      $rootScope.CurrentOrganization.integrations = $rootScope.CurrentAccount.isAdministrator
        ? data[1]?.integrations
        : null;
      accountsService.clearCache();
    })
    .then(() => {
      // Declare Model as Ready and start rendering the page
      webpage.pageTitle('3rd party applications : Settings');
      $scope.Model.isReady = true;
    });

  // #region Campaign monitor
  $scope.campaignMonitorAuthentication = () => {
    if (!$rootScope.CurrentOrganization.isCampaignMonitorEnabled()) {
      $scope.Model.showCampaignMonitor = true;
      uiService.toast({
        text: {
          p1: 'Initializing',
          p2: 'campaignMonitor',
          p3: 'authentication'
        },
        progress: true
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Revoking',
          p2: 'campaignMonitor',
          p3: 'authentication'
        },
        progress: true
      });
      $timeout(() => {
        $scope.campaignMonitorFinished();
      });
    }
  };

  $scope.campaignMonitorFinished = (result) => {
    $scope.Model.showCampaignMonitor = false;
    $rootScope.CurrentOrganization.integrations.campaignMonitor = {
      autoSync: false,
      autoSyncList: null,
      autoSyncListId: null,
      clientId: null,
      clientEmail: null,
      token: null,
      integrator: null,
      enabled: false
    };
    if (result) {
      $rootScope.CurrentOrganization.integrations.campaignMonitor = {
        autoSync: false,
        autoSyncList: null,
        autoSyncListId: null,
        clientId: result.clientId,
        clientEmail: result.clientEmail,
        token: result.token,
        integrator: result.integrator,
        enabled: true
      };
    }
    $scope.saveChanges({
      id: $rootScope.CurrentOrganization.id,
      integrations: {
        campaignMonitor: $rootScope.CurrentOrganization.integrations.campaignMonitor
      }
    });
  };

  $scope.campaignMonitorAutoSync = () => {
    if ($rootScope.CurrentAccount.isAdministrator) {
      $timeout(() => {
        if (
          $rootScope.CurrentOrganization.isCampaignMonitorEnabled() &&
          $rootScope.CurrentOrganization.integrations.campaignMonitor.autoSync
        ) {
          $scope.Model.showCampaignMonitorAutoSync = true;
        } else {
          $scope.campaignMonitorAutoSyncFinished();
        }
      });
    }
  };

  $scope.campaignMonitorAutoSyncFinished = (result) => {
    if ($rootScope.CurrentAccount.isAdministrator) {
      $scope.Model.showCampaignMonitorAutoSync = false;
      $rootScope.CurrentOrganization.integrations.campaignMonitor.autoSync = false;
      $rootScope.CurrentOrganization.integrations.campaignMonitor.autoSyncList = null;
      $rootScope.CurrentOrganization.integrations.campaignMonitor.autoSyncListId = null;
      if ($rootScope.CurrentOrganization.isCampaignMonitorEnabled() && result) {
        $rootScope.CurrentOrganization.integrations.campaignMonitor.autoSync = true;
        $rootScope.CurrentOrganization.integrations.campaignMonitor.autoSyncList = result.name;
        $rootScope.CurrentOrganization.integrations.campaignMonitor.autoSyncListId = result.id;
      }
      $scope.saveChanges({
        id: $rootScope.CurrentOrganization.id,
        integrations: {
          campaignMonitor: $rootScope.CurrentOrganization.integrations.campaignMonitor
        }
      });
      campaignMonitorService.sync();
    }
  };
  // #endregion Campaign monitor

  // #region Pepper Asset Finance
  $scope.pepperAssetFinanceAuthentication = () => {
    if (
      !(
        $rootScope.CurrentOrganization.integrations.pepperAssetFinance &&
        $rootScope.CurrentOrganization.integrations.pepperAssetFinance.enabled
      )
    ) {
      $scope.Model.showPepperAssetFinance = true;
      uiService.toast({
        text: {
          p1: 'Initializing',
          p2: 'Pepper Asset Finance',
          p3: 'authentication'
        },
        progress: true
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Revoking',
          p2: 'Pepper Asset Finance',
          p3: 'authentication'
        },
        progress: true
      });
      $timeout(() => {
        $scope.pepperAssetFinanceAuthenticationFinished();
      });
    }
  };

  $scope.pepperAssetFinanceAuthenticationFinished = (result) => {
    $scope.Model.showPepperAssetFinance = false;
    $rootScope.CurrentOrganization.integrations.pepperAssetFinance = {
      enabled: false,
      merchantId: null
    };
    if (result) {
      $rootScope.CurrentOrganization.integrations.pepperAssetFinance = {
        enabled: true,
        merchantId: result
      };
    }
    $scope.saveChanges({
      id: $rootScope.CurrentOrganization.id,
      integrations: {
        pepperAssetFinance: $rootScope.CurrentOrganization.integrations.pepperAssetFinance
      }
    });
  };
  // #endregion Pepper Asset Finance

  // #region ID Smart
  $scope.idSmartAuthentication = () => {
    $scope.saveChanges({
      id: $rootScope.CurrentOrganization.id,
      integrations: { idSmart: $rootScope.CurrentOrganization.integrations.idSmart }
    });
  };
  // #endregion ID Smart

  // #region Mailchimp
  $scope.mailChimpAuthentication = () => {
    if ($rootScope.CurrentAccount.isAdministrator) {
      if (!$rootScope.CurrentOrganization.isMailChimpEnabled()) {
        uiService.toast({
          text: {
            p1: 'Initializing',
            p2: 'MailChimp',
            p3: 'authentication'
          },
          progress: true
        });
        mailChimpService.authenticate().then((response) => {
          if (response.status) {
            $window.location.href = response.url;
          } else {
            uiService.toast({
              text: {
                p1: 'MailChimp',
                p2: 'is currently',
                p3: 'unavailable'
              },
              warn: true
            });
          }
        });
      } else {
        uiService.toast({
          text: {
            p1: 'Revoking',
            p2: 'MailChimp',
            p3: 'authentication'
          },
          progress: true
        });
        mailChimpService.deauthenticate().then(() => {
          $timeout(() => {
            $rootScope.CurrentOrganization.integrations.mailChimp = {
              autoSync: false,
              autoSyncList: null,
              autoSyncListId: null,
              metaData: null,
              token: null,
              enabled: false
            };
            $scope.saveChanges({
              id: $rootScope.CurrentOrganization.id,
              integrations: {
                mailChimp: $rootScope.CurrentOrganization.integrations.mailChimp
              }
            });
          });
        });
      }
    }
  };

  $scope.mailChimpAutoSync = () => {
    if ($rootScope.CurrentAccount.isAdministrator) {
      $timeout(() => {
        if (
          $rootScope.CurrentOrganization.isMailChimpEnabled() &&
          $rootScope.CurrentOrganization.integrations.mailChimp.autoSync
        ) {
          $scope.Model.showMailChimpAutoSync = true;
        } else {
          $scope.mailChimpAutoSyncFinished();
        }
      });
    }
  };

  $scope.mailChimpAutoSyncFinished = (result) => {
    if ($rootScope.CurrentAccount.isAdministrator) {
      $scope.Model.showMailChimpAutoSync = false;
      $rootScope.CurrentOrganization.integrations.mailChimp.autoSync = false;
      $rootScope.CurrentOrganization.integrations.mailChimp.autoSyncList = null;
      $rootScope.CurrentOrganization.integrations.mailChimp.autoSyncListId = null;
      if ($rootScope.CurrentOrganization.isMailChimpEnabled() && result) {
        $rootScope.CurrentOrganization.integrations.mailChimp.autoSync = true;
        $rootScope.CurrentOrganization.integrations.mailChimp.autoSyncList = result.name;
        $rootScope.CurrentOrganization.integrations.mailChimp.autoSyncListId = result.id;
      }
      $scope.saveChanges({
        id: $rootScope.CurrentOrganization.id,
        integrations: { mailChimp: $rootScope.CurrentOrganization.integrations.mailChimp }
      });
      mailChimpService.sync();
    }
  };
  // #endregion Mailchimp

  // #region Invitation content
  $scope.onEditInvitationContentFinished = (result) => {
    if (result.id === 'idSmart') {
      $rootScope.CurrentOrganization.integrations[result.id].emailCustomContent =
        result.content;
      $scope.saveChanges({
        id: $rootScope.CurrentOrganization.id,
        integrations: {
          [result.id]: {
            emailCustomContent: result.content || ''
          }
        }
      });
    }
  };
  // #endregion Invitation content

  // #region LoanQ
  $scope.loanqActivate = () => {
    if (!$rootScope.CurrentOrganization.integrations.loanq?.enabled) {
      $scope.Model.showLoanq = true;
    } else {
      uiService.toast({
        text: {
          p1: 'Removing',
          p2: 'LoanQ',
          p3: 'integration'
        },
        progress: true
      });
      $timeout(() => {
        $scope.loanqFinished();
      });
    }
  };

  $scope.loanqEdit = () => {
    $scope.Model.showLoanq = true;
  };

  $scope.loanqFinished = (result) => {
    $scope.Model.showLoanq = false;

    $rootScope.CurrentOrganization.integrations.loanq = {
      idWorkflow: result?.idWorkflow || '',
      enabled: isUUID(result?.idWorkflow)
    };

    $scope.saveChanges({
      id: $rootScope.CurrentOrganization.id,
      integrations: { loanq: $rootScope.CurrentOrganization?.integrations?.loanq || {} }
    });
  };
  // #endregion LoanQ

  $scope.saveAccount = (data) => {
    const accountData = data?.data;
    if (accountData?.id && !_.isEmpty(accountData?.integrations) && accountData?.integration) {
      $rootScope.CurrentAccount.integrations[accountData?.integration] =
        accountData.integrations[accountData?.integration];
      if (!accountData?.noNeedToUpdate) {
        $scope.saveChanges(accountData, true);
      } else {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
      }
    }
  };

  $scope.saveChanges = (payload, isAccount) => {
    const handler = isAccount
      ? accountService.updateAccount(payload)
      : organizationService.updateOrganization(payload);
    handler.then((result) => {
      if (result.status) {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        uiService.toast({
          text: {
            p1: 'Saving',
            p2: 'your',
            p3: 'changes ...'
          },
          progress: true
        });
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
    });
  };
};
